/**
 * The router keeps the page being left behind mounted until the whole navigation resolves -
 * redirect hops and lazily loaded route components included - so a load that finishes first has
 * to keep its loading screen up until then, or the old page flashes back into view.
 */
import { ref } from 'vue';

/** Whether a navigation is in flight, see {@link holdForNavigation}. */
let navigating = false;

/** Whether the loading screen is being held up for the rest of a navigation. */
export const heldForNavigation = ref(false);

/** Called as a load finishes, to keep its loading screen up for the rest of the navigation. */
export function holdForNavigation(): void {
  if (navigating) {
    heldForNavigation.value = true;
  }
}

export function navigationStarted(): void {
  navigating = true;
}

export function navigationEnded(): void {
  navigating = false;
  heldForNavigation.value = false;
}
